import { __assign } from "tslib";
import React from 'react';
import ProGallerySlider from './ProGallerySlider';
import FullscreenSidebar from './fullscreenSidebar.js';
import { getBaseStyles } from './proGallerySliderFixedStyles';
function getGallerySliderBaseProps(props) {
    var _props = {
        items: props.items,
        totalItemsCount: props.totalItems,
        activeIndex: props.current.item.idx,
        actions: props.actions,
        currentWindow: props.currentWindow,
        staticMediaUrls: props.staticMediaUrls,
        isAccessible: props.isAccessible,
        isPreview: props.isPreview,
        isPrerenderMode: props.isPrerenderMode,
    };
    return _props;
}
function fullscreenRenderer(_a) {
    var setRef = _a.setRef, fullscreenClasses = _a.fullscreenClasses, comp = _a.comp, style = _a.style;
    return (React.createElement("div", { key: 'fullscreen-view', ref: function (ref) { return setRef(ref); }, "data-hook": "fullscreen-view", id: "fullscreen-view", className: fullscreenClasses, style: style, role: "dialog", tabIndex: -1, "aria-label": "Gallery item, detailed view" }, comp));
}
function sidebarRenderer(props) {
    var shouldShowInfo = props.shouldShowInfo, hasAdditionalSidebarElement = props.hasAdditionalSidebarElement;
    if (!shouldShowInfo && !hasAdditionalSidebarElement) {
        return null;
    }
    return React.createElement(FullscreenSidebar, __assign({}, props));
}
function proGallerySliderRender(_a) {
    var props = _a.props, containerPostProcess = _a.containerPostProcess, galleryProps = _a.galleryProps, classNames = _a.classNames, style = _a.style;
    return (React.createElement("div", { key: 'pro-gallery-fullscreen-slider-wrapper', className: classNames, style: style },
        React.createElement(ProGallerySlider, __assign({}, galleryProps, { isPrerenderMode: props.isPrerenderMode, containerPostProcess: containerPostProcess }))));
}
function renderSlider(_a) {
    var props = _a.props, aditionalStyles = _a.aditionalStyles, container = _a.container, containerPostProcess = _a.containerPostProcess, isTouchDeviceZoom = _a.isTouchDeviceZoom, customInfoRenderer = _a.customInfoRenderer, classNames = _a.classNames, _b = _a.style, style = _b === void 0 ? {} : _b;
    var galleryStyles = __assign(__assign({}, getBaseStyles(props.styles)), aditionalStyles);
    var galleryProps = __assign(__assign({}, getGallerySliderBaseProps(props)), { styles: galleryStyles, container: container, customInfoRenderer: customInfoRenderer });
    return getFullscreenSlider({
        props: props,
        containerPostProcess: containerPostProcess,
        galleryProps: galleryProps,
        isExpandedView: props.isFullscreen,
        isTouchDeviceZoom: false,
        classNames: classNames,
    });
}
function getFullscreenSlider(_a) {
    var props = _a.props, containerPostProcess = _a.containerPostProcess, galleryProps = _a.galleryProps, classNames = _a.classNames, style = _a.style, isExpandedView = _a.isExpandedView, isTouchDeviceZoom = _a.isTouchDeviceZoom;
    return proGallerySliderRender({
        props: props,
        containerPostProcess: containerPostProcess,
        galleryProps: galleryProps,
        classNames: classNames,
        style: style,
    });
}
export { sidebarRenderer, fullscreenRenderer, getGallerySliderBaseProps, renderSlider, };
//# sourceMappingURL=expandUtils.js.map